import React from 'react';
import PromoPage from './pages/PromoPage';

function App() {
  return (
    <div className="App">
      <PromoPage />
    </div>
  );
}

export default App;
